"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableQueryUnbondingDelegations = exports.ObservableQueryUnbondingDelegationsInner = void 0;
const chain_query_1 = require("../../chain-query");
const unit_1 = require("@keplr-wallet/unit");
const mobx_1 = require("mobx");
class ObservableQueryUnbondingDelegationsInner extends chain_query_1.ObservableChainQuery {
    constructor(kvStore, chainId, chainGetter, bech32Address) {
        super(kvStore, chainId, chainGetter, `/staking/delegators/${bech32Address}/unbonding_delegations`);
        mobx_1.makeObservable(this);
        this.bech32Address = bech32Address;
    }
    canFetch() {
        // If bech32 address is empty, it will always fail, so don't need to fetch it.
        return this.bech32Address.length > 0;
    }
    get total() {
        const stakeCurrency = this.chainGetter.getChain(this.chainId).stakeCurrency;
        if (!this.response) {
            return new unit_1.CoinPretty(stakeCurrency, new unit_1.Int(0)).ready(false);
        }
        let totalBalance = new unit_1.Int(0);
        for (const unbondingDelegation of this.response.data.result) {
            for (const entry of unbondingDelegation.entries) {
                totalBalance = totalBalance.add(new unit_1.Int(entry.balance));
            }
        }
        return new unit_1.CoinPretty(stakeCurrency, totalBalance);
    }
    get unbondingBalances() {
        const unbondings = this.unbondings;
        const stakeCurrency = this.chainGetter.getChain(this.chainId).stakeCurrency;
        const result = [];
        for (const unbonding of unbondings) {
            const entries = [];
            for (const entry of unbonding.entries) {
                entries.push({
                    creationHeight: new unit_1.Int(entry.creation_height),
                    completionTime: entry.completion_time,
                    balance: new unit_1.CoinPretty(stakeCurrency, new unit_1.Int(entry.balance)),
                });
            }
            result.push({
                validatorAddress: unbonding.validator_address,
                entries,
            });
        }
        return result;
    }
    get unbondings() {
        if (!this.response) {
            return [];
        }
        return this.response.data.result;
    }
}
__decorate([
    mobx_1.computed
], ObservableQueryUnbondingDelegationsInner.prototype, "total", null);
__decorate([
    mobx_1.computed
], ObservableQueryUnbondingDelegationsInner.prototype, "unbondingBalances", null);
__decorate([
    mobx_1.computed
], ObservableQueryUnbondingDelegationsInner.prototype, "unbondings", null);
exports.ObservableQueryUnbondingDelegationsInner = ObservableQueryUnbondingDelegationsInner;
class ObservableQueryUnbondingDelegations extends chain_query_1.ObservableChainQueryMap {
    constructor(kvStore, chainId, chainGetter) {
        super(kvStore, chainId, chainGetter, (bech32Address) => {
            return new ObservableQueryUnbondingDelegationsInner(this.kvStore, this.chainId, this.chainGetter, bech32Address);
        });
        this.kvStore = kvStore;
        this.chainId = chainId;
        this.chainGetter = chainGetter;
    }
    getQueryBech32Address(bech32Address) {
        return this.get(bech32Address);
    }
}
exports.ObservableQueryUnbondingDelegations = ObservableQueryUnbondingDelegations;
//# sourceMappingURL=unbonding-delegations.js.map